import {
  ApiOptions,
  get,
  httpDelete,
  put,
  uploadFile,
  uploadFiles,
} from "../api";
import type { CalendarPermissionLevel, UpdateUserSettingsBody } from "../types";
import type { EmailPreference, EmailPreferences } from "../types/emailTypes";

export const updateUserSettings = async (
  settings: UpdateUserSettingsBody,
  options?: ApiOptions,
): Promise<void> =>
  put("/users/me/settings", settings, {
    withCreds: true,
    ...options,
  });

export const updateCalendarPrefs = async (
  permissionLevel: CalendarPermissionLevel,
): Promise<void> => {
  return put(`/users/me/calendar`, { permissionLevel }, { withCreds: true });
};

export const getEmailPreferences = async (): Promise<EmailPreferences> =>
  get("/users/settings/email-preferences", { withCreds: true });

type UpdateEmailPreferencesBody = { data: EmailPreference[] };

export const updateEmailPreferences = async (
  body: UpdateEmailPreferencesBody,
): Promise<void> =>
  put("/users/settings/email-preferences", body, {
    withCreds: true,
  });

export const uploadAvatars = async (body: {
  original: File;
  cropped: File;
}): Promise<void> => {
  return uploadFiles("/users/me/avatar", body, { withCreds: true });
};

export const updateAvatar = async (file: File): Promise<void> => {
  return uploadFile("/users/me/avatar", file, { withCreds: true });
};

export const deleteAvatars = async (): Promise<void> => {
  return httpDelete("/users/me/avatar", { withCreds: true });
};
